<template>
  <div>
    <section class="hero is-dark is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <div class="column is-6 is-offset-3">
            <div class="card">
              <div class="hero is-light">
                <div class="hero-body">
                  <div class="container">
                    <span>
                      <img width="80%" src="@/assets/logo2.png" alt="Logo" />
                    </span>
                    <br /><br />
                    <h1 class="title is-3 has-text-grey">
                      CL7 - CLIMA LABORAL
                    </h1>
                  </div>
                </div>
              </div>
              <div class="hero is-white">
                <div class="hero-body">
                  <div class="container">
                    <div class="notification has-text-left is-link">
                      Por favor digita tu cédula para ingresar a la encuesta.
                    </div>
                    <div class="field">
                      <div class="control has-icons-left">
                        <input
                          v-model="validate.cedula"
                          class="input is-large"
                          type="text"
                          placeholder="Cédula"
                          autocomplete="off"
                        />
                        <span class="icon is-medium is-left">
                          <i class="material-icons">done</i>
                        </span>
                      </div>
                    </div>
                    <button
                      class="button is-block is-info is-large is-fullwidth"
                      @click="valida"
                    >
                      ENTRAR
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services-public";
export default {
  data() {
    return {
      validate: {
        cedula: null,
        codigo: null,
      },
    };
  },
  methods: {
    async valida() {
      try {
        if (!this.validate.cedula) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar su cédula sin puntos ni comas.",
            type: "is-warning",
            duration: 4000,
            position: "top-center",
          });
          return false;
        }
        const result = await apiServices.post(`/accessclima`, this.validate);
        if (result.data) {
          if (result.data.error) {
            this.$store.dispatch("notify", {
              message: result.data.message,
              type: "is-info",
              duration: 6000,
              position: "top-center",
            });
          } else {
            this.$router.replace({
              name: "encuestaclima",
              params: { id: result.data._id },
            });
          }
        }
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un error pongase en contacto con Siete.",
          type: "is-danger",
          duration: 4000,
          position: "top-center",
        });
      }
    },
  },
  created() {
    this.validate.codigo = this.$route.params.codigo;
    console.log("el codigo de la encuesta es", this.validate);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/climan/AccessEncuesta.vue